import React from "react";
import FooterOne from "../common/footer/FooterOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SEO from "../common/SEO";
import HeaderFour from "../common/header/HeaderFour";
import ChatbotTwo from "./ChatbotTwo";

const PrivacyPolicy = () => {
  return (
    <>
      <SEO />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderFour />
        <BreadCrumbOne title="Privacy Policy" page="Privacy Policy" />
        <div className="section-padding privacy-policy-area">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="privacy-policy-content">
                  <h1>Privacy Policy for CLIF AI</h1>
                  <p>Last Updated: February 21, 2025</p>
                  <h2>Introduction</h2>
                  <p>
                    Welcome to CLIF AI ("Company", "we", "our", "us"). Our Privacy Policy governs your visit to https://clif.ai, and explains how we collect, safeguard, and disclose information that results from your use of our Service.
                  </p>
                  <p>
                    By using the Service, you agree to the collection and use of information in accordance with this policy.
                  </p>
                  <h2>Definitions</h2>
                  <p><strong>Service:</strong> The https://clif.ai website operated by CLIF AI.</p>
                  <p><strong>Personal Data:</strong> Data about a living individual who can be identified from those data.</p>
                  <p><strong>Usage Data:</strong> Data collected automatically either generated by the use of Service or from Service infrastructure itself.</p>
                  <p><strong>Cookies:</strong> Small files stored on your device (computer or mobile device).</p>
                  <h2>Information Collection and Use</h2>
                  <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>
                  <h3>Types of Data Collected</h3>
                  <h4>Personal Data</h4>
                  <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). This may include, but is not limited to:</p>
                  <ul>
                    <li>Email address</li>
                    <li>First name and last name</li>
                    <li>Phone number</li>
                    <li>Address, State, Province, ZIP/Postal code, City</li>
                    <li>Cookies and Usage Data</li>
                    <li>Your Professional Resume</li>
                  </ul>
                  <h4>Usage Data</h4>
                  <p>We may also collect information that your browser sends whenever you visit our Service or when you access Service by or through a mobile device ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g., IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
                  <h3>Use of Data</h3>
                  <p>CLIF AI uses the collected data for various purposes:</p>
                  <ul>
                    <li>To provide and maintain our Service</li>
                    <li>To notify you about changes to our Service</li>
                    <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
                    <li>To provide customer support</li>
                    <li>To gather analysis or valuable information so that we can improve our Service</li>
                    <li>To monitor the usage of our Service</li>
                    <li>To detect, prevent and address technical issues</li>
                    <li>To fulfill any other purpose for which you provide it</li>
                    <li>To carry out our obligations and enforce our rights arising from any contracts entered into between you and us</li>
                    <li>To use your data for research, model training, and educational purposes</li>
                    <li>In any other way we may describe when you provide the information</li>
                    <li>For any other purpose with your consent</li>
                  </ul>
                  <h3>Data Sharing and Disclosure</h3>
                  <p>We may share your information in the following situations:</p>
                  <ul>
                    <li><strong>With Service Providers:</strong> We may share your personal information with Service Providers to monitor and analyze the use of our Service, to contact you.</li>
                    <li><strong>For Business Transfers:</strong> We may share or transfer your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of our business to another company.</li>
                    <li><strong>With Affiliates:</strong> We may share your information with our affiliates, in which case we will require those affiliates to honor this Privacy Policy.</li>
                    <li><strong>With Business Partners:</strong> We may share your information with our business partners to offer you certain products, services or promotions.</li>
                    <li><strong>With Your Consent:</strong> We may disclose your personal information for any other purpose with your consent.</li>
                  </ul>
                  <h3>Data Security</h3>
                  <p>The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>
                  <h3>Your Data Protection Rights</h3>
                  <p>Depending on your location, you may have the following rights regarding your personal data:</p>
                  <ul>
                    <li>The right to access, update or delete the information we have on you.</li>
                    <li>The right of rectification.</li>
                    <li>The right to object.</li>
                    <li>The right of restriction.</li>
                    <li>The right to data portability.</li>
                    <li>The right to withdraw consent.</li>
                  </ul>
                  <p>Please note that we may ask you to verify your identity before responding to such requests.</p>
                  <h3>Children's Privacy</h3>
                  <p>Our Service does not address anyone under the age of 13 ("Children"). We do not knowingly collect personally identifiable information from anyone under the age of 13. If you are a parent or guardian and you are aware that your child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent.</p>
                  <h2>Contact Information</h2>
                  <p>If you have any questions about this Privacy Policy, You can contact us at <a href="mailto:connect@clif.ai">connect@clif.ai</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CtaLayoutOne />
        <FooterOne parentClass="" />
        <ChatbotTwo />
      </main>
    </>
  );
};

export default PrivacyPolicy;